$(".variant-picker__wrapper input[type=radio]").change((function() {
  var variantVal = $(this).val();
  var variantPolicy = $(this).attr('data-vpolicy');
  var variantQty = $(this).attr('data-vqty');
  
  
  // klavio form display on soldout variant and policy deny
  if($(this).hasClass("sold-out") && variantPolicy == 'deny'){
      $('.app_inner_wrp.klavio_waitlist_form').addClass('soldout__variant');
  }else {
    $('.app_inner_wrp.klavio_waitlist_form').removeClass('soldout__variant');
  }

  // show preorder button and custom info message pass variant nameon change
  if(variantPolicy == 'continue' && variantQty <= 0){
    $('.custom_ava_info_text_wrp').removeClass('show_avaiable_info');
    $('.custom_info_text_wrp').addClass('show_message');
    if(variantVal != 'Default Title'){
      var customInfo = $(this).closest(".product__form__wrapper").find('.custom_info_text_wrp p span.vartxt');
      if(customInfo && variantVal){
        customInfo.text(variantVal);
      }
    }
    setTimeout(function () {
    if($('.custom_info_text_wrp').hasClass('show_message')){
        $('span.atc_txxt').text(theme.strings.preorder);
      }
    },1000);
  }else{
    
    if($(this).hasClass("sold-out")){
      $('.custom_ava_info_text_wrp').removeClass('show_avaiable_info');
    }else{
       $('.custom_info_text_wrp').removeClass('show_message');
       $('.custom_ava_info_text_wrp').addClass('show_avaiable_info');
       if(variantVal != 'Default Title'){
          var customInfo = $(this).closest(".product__form__wrapper").find('.custom_ava_info_text_wrp p span.vartxt');
          if(customInfo && variantVal){
            customInfo.text(variantVal);
          }
       }
    }
  }

  // color swatch selected value assign to addon checkbox addon products
   var variantObj = $(this);
  //  console.log(variantObj);
   var addonSelectedVal = $(this).next().attr('data-myvariant');
   var addonSelectedImgVal = $(this).next().attr('data-myvariantimg');
   $(this).closest('.main_addon_wrp').find('input[type=checkbox]').val(addonSelectedVal);
   $(this).closest('.main_addon_wrp').find('.product-addon_product__image__thumb').css('background-image', 'url(' + addonSelectedImgVal + ')');



  // product upsell id change on change
        var mySelectedVal = $(this).next().attr('data-myvariant');
        var mySelectedImgVal = $(this).next().attr('data-myvariantimg');
        var myvariantavailable = this.nextElementSibling.getAttribute('data-myvariantavailable');
        var btn = this.closest('form.product-upsell__form').querySelector('.product-upsell__btn');

        if (myvariantavailable === "false") {
          btn.classList.add("disabled");
        } else {
          btn.classList.remove("disabled");
        }
        $(this).closest('form.product-upsell__form').find('input[name=id]').val(mySelectedVal);
        $(this).closest('.product-upsell__holder').find('.product-upsell__image__thumb').css('background-image', 'url(' + mySelectedImgVal + ')');

}));
// product upsell
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".swatch__label").forEach(function (label) {
    if (label.dataset.myvariantavailable === "false") {
      const swatchButton = label.closest(".swatch__button");
      if (swatchButton) {
        const input = swatchButton.querySelector("input[type='radio']");
        if (input) {
          input.classList.add("sold-out");
        }
      }
    }
  });
});


$(document).ready(function(){
  setTimeout(function () {
    if($('.custom_info_text_wrp').hasClass('show_message')){
      $('span.atc_txxt').text(theme.strings.preorder);
    }
  },1000);
});


// bundle page swatch hide show message
$(document).ready(function () {
  $('.bundle-color-swatch .radio__fieldset .swatch__button').on('click', function() {
    var dataInfo = $(this).find('.swatch__label');
    var messageinfoAvailableSelector = $(this).closest('.bundle-builder').find('.custom_ava_info_text_wrp');
    var messageinfoSoldoutSelector = $(this).closest('.bundle-builder').find('.custom_info_text_wrp');
    var variantVal = dataInfo.attr('data-variant-title');
    var variantPolicy = dataInfo.attr('data-vpolicy');
    var variantQty = dataInfo.attr('data-vqty');

    

    // custom info message pass variant nameon change
    if(variantPolicy == 'continue' && variantQty <= 0){
      console.log(messageinfoAvailableSelector);
      console.log(messageinfoSoldoutSelector);
       messageinfoAvailableSelector.removeClass('show_avaiable_info');
       messageinfoSoldoutSelector.addClass('show_message');
      if(variantVal != 'Default Title'){
        var customInfo = messageinfoSoldoutSelector.find('p span.vartxt');
        if(customInfo && variantVal){
          customInfo.text(variantVal);
        }
      }
      
    }else{
        messageinfoSoldoutSelector.removeClass('show_message');
        messageinfoAvailableSelector.addClass('show_avaiable_info');
       if(variantVal != 'Default Title'){
          var customInfo = messageinfoAvailableSelector.find('p span.vartxt');
          if(customInfo && variantVal){
            customInfo.text(variantVal);
          }
       }
    }
    
  });
});

// landing page Auto atc product
var autopid = 56113759846782; // extra product variant ID
let autoAdded = false;
console.log("loaded");

document.addEventListener('click', async (e) => {

  const btn = e.target.closest('#ctm_btn_ecomp_set .ecom-product-single__add-to-cart--submit');
  if (!btn || autoAdded) return;

  autoAdded = true;
  e.preventDefault();

  try {
    // Get main product quantity
    const qtyInput = document.querySelector('.ecom-product-single__quantity-input');
    const mainQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    // Prepare data for CO2 cylinder (extra product)
    const data = {
      items: [{ id: autopid, quantity: mainQty }]
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Extra product add failed');
    console.log(`✅ Extra product added (${mainQty}x)`);

    // Proceed with main product add
    btn.click();
  } catch (err) {
    console.error('❌ Auto ATC failed:', err);
    btn.click();
  } finally {
    autoAdded = false; // reset flag for next click
  }
});




document.addEventListener("DOMContentLoaded", function () {

   // STEP 1 — Trigger click on the first subscription group radio (not one-time)
   setTimeout(function(){
     const firstGroup = document.querySelector('input[name="selling-plan-group"]:not([value=""])');
     if (firstGroup) {
       firstGroup.click(); // real click event
     }
   },1000);

  

  // Listen for subscription plan changes
  document.querySelectorAll('[name="selling-plan-group"], [name="selling_plan"]').forEach(input => {
    input.addEventListener("change", function (event) {

      // Find correct bundle block
      const bundleWrapper = event.target.closest('.bundle-wrapper, .bundle-picker__wrapper');

      if (!bundleWrapper) return;

      // Read selected plan
      const selected = bundleWrapper.querySelector('input[name="selling_plan"]:checked');
      const planValue = selected ? selected.value : "";

      // Update hidden selling plan input inside this bundle
      const hiddenField = bundleWrapper.querySelector('.bundle-selling-plan');
      if (hiddenField) {
        hiddenField.value = planValue;
        console.log("Updated selling plan:", planValue);
      }
    });
  });

});


// saved amount badge subscription widget
document.addEventListener("DOMContentLoaded", function () {

  function getMaxSubscriptionSave() {
    let max = 0;

    document.querySelectorAll('input[name="selling_plan"][data-save-raw]').forEach(input => {
      const val = parseFloat(input.dataset.saveRaw);
      if (!isNaN(val)) {
        max = Math.max(max, val);
      }
    });

    return max;
  }

  function updateSaveBoxFromPlan(planInput) {
    const saveBox = document.querySelector('.saved_txt_plan');
    if (!saveBox) return;

    const save = planInput.dataset.save || '';

    if (save) {
      saveBox.textContent = `save: ${save}`;
      saveBox.classList.remove('hidden');
    } else {
      saveBox.textContent = '';
      saveBox.classList.add('hidden');
    }
  }

  function updateSaveBoxForOneTime() {
    const saveBox = document.querySelector('.saved_txt_plan');
    if (!saveBox) return;

    const maxSave = getMaxSubscriptionSave();

    if (maxSave > 0) {
      saveBox.textContent = `save: ${maxSave}%`;
      saveBox.classList.remove('hidden');
    } else {
      saveBox.textContent = '';
      saveBox.classList.add('hidden');
    }
  }

  /* --------------------
     SUBSCRIPTION PLAN CHANGE
  -------------------- */
  document.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
    radio.addEventListener('change', function () {
      updateSaveBoxFromPlan(this);
    });
  });

  /* --------------------
     PLAN GROUP CHANGE (One-time / Subscription)
  -------------------- */
  document.querySelectorAll('input[name="selling-plan-group"]').forEach(radio => {
    radio.addEventListener('change', function () {
      // One-time purchase → value is empty
      if (this.value === "") {
        updateSaveBoxForOneTime();
      }
    });
  });

  /* --------------------
     INITIAL LOAD
  -------------------- */
  const checkedPlan = document.querySelector('input[name="selling_plan"]:checked');
  if (checkedPlan) {
    updateSaveBoxFromPlan(checkedPlan);
  }

});


// 
// 
// 
// 
// 
// 
document.addEventListener('change', function (e) {

  /* ===============================
     SELLING PLAN GROUP TOGGLE
  ================================ */
  if (e.target.matches('input[type="radio"][name^="selling-plan-group-"]')) {
    const radio = e.target;
    const subsForm = radio.closest('.product__subs');
    const bundle = radio.closest('.bundle-wrapper');
    if (!subsForm || !bundle) return;

    const groupId = radio.value;

    // Hide only this product’s plans
    subsForm.querySelectorAll('.product__subs__plans').forEach(p => {
      p.classList.add('hidden');
    });

    // Open selected group
    if (groupId) {
      const active = subsForm.querySelector(
        `.product__subs__plans[data-group-toggle-ctm="${groupId}"]`
      );
      if (active) {
        active.classList.remove('hidden');

        // Auto-select first plan
        const firstPlan = active.querySelector(
          'input[type="radio"][name^="selling_plan_"]'
        );
        if (firstPlan && !firstPlan.checked) {
          firstPlan.checked = true;
          firstPlan.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else {
      // One-time purchase → clear hidden selling plan
      const hidden = bundle.querySelector('.bundle-selling-plan');
      if (hidden) hidden.value = '';
    }
  }

  /* ===============================
     SELLING PLAN SELECTION
  ================================ */
  if (e.target.matches('input[type="radio"][name^="selling_plan_"]')) {
    const planRadio = e.target;
    const bundle = planRadio.closest('.bundle-wrapper');
    if (!bundle) return;

    // Update hidden input
    const hidden = bundle.querySelector('.bundle-selling-plan');
    if (hidden) hidden.value = planRadio.value;

    // Update save text (SCOPED)
    const save = planRadio.dataset.save || '';
    const saveBox = planRadio
      .closest('.product__subs')
      .querySelector('.saved_txt_plan');
    console.log(save, "new save code");
    if (saveBox) {
      if (save) {
        saveBox.textContent = `save: ${save}`;
        saveBox.classList.remove('hidden');
      } else {
        saveBox.textContent = '';
        saveBox.classList.add('hidden');
      }
    }
  }

});

document.querySelectorAll('.bundle-wrapper').forEach(bundle => {
  const firstGroup = bundle.querySelector(
    'input[type="radio"][name^="selling-plan-group-"]:not([value=""])'
  );
  if (firstGroup) firstGroup.click();
});



// document.addEventListener('click', function (e) {
//   const tab = e.target.closest('.bundle-tab');
//   if (!tab) return;

//   const index = tab.dataset.bundleTab;

//   document.querySelectorAll('.bundle-tab').forEach(btn => {
//     btn.classList.toggle('active', btn === tab);
//   });

//   document.querySelectorAll('.bundle-picker__wrapperrr').forEach(wrapper => {
//     wrapper.classList.toggle(
//       'hidden',
//       wrapper.dataset.bundleContent !== index
//     );

//     wrapper.querySelectorAll('[name="selling_plan"]').forEach(input => {
//       input.disabled = wrapper.dataset.bundleContent !== index;
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".bundle-tab");
  const contents = document.querySelectorAll(".bundle-picker__wrapperrr");

  function activateTab(activeIndex) {
    contents.forEach((wrapper, index) => {
      const isActive = index === activeIndex;

      // show / hide
      wrapper.classList.toggle("hidden", !isActive);

      // 🔑 ONLY ACTIVE TAB SUBMITS
      wrapper.querySelectorAll("input").forEach(input => {
        input.disabled = !isActive;
      });
    });

    tabs.forEach((tab, i) => {
      tab.classList.toggle("active", i === activeIndex);
    });
  }

  // init → first tab only
  activateTab(0);

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      activateTab(index);
    });
  });
});
